import type { LastName } from '@/shared/schemas/last-name'
import type { Name } from '@/shared/schemas/name'

export const buildName = (name: Name | undefined, lastName: LastName | undefined): string => {
  let fullname = ''
  if (name === undefined || lastName === undefined) return fullname
  if (name?.first) fullname += name.first
  if (name?.second) fullname += ` ${name.second}`
  if (name?.others) fullname += ` ${name.others}`
  if (lastName?.first) fullname += ` ${lastName.first}`
  if (lastName?.second) fullname += ` ${lastName.second}`
  if (lastName?.married) fullname += ` DE ${lastName.married}`
  return fullname
}

export const getFullName = (name?: Name, lastName?: LastName): string => {
  const parts: Array<string | undefined> = [
    ...(name ? Object.values(name) : []),
    ...(lastName ? Object.values(lastName) : [])
  ]
  return parts
    .filter((value): value is string => Boolean(value))
    .map((value) => ` ${value}`)
    .join('')
    .trim()
}

export const transformFirtsLetterWord = (word: string) => {
  const words = word.split(' ')
  const newWords = words.map((w) => {
    return w.charAt(0).toUpperCase() + w.substring(1)
  })
  return newWords.join(' ')
}

export function joinPath(...paths: string[]) {
  return paths.join('/').replace(/\/+/g, '/')
}

export function formatBytes(bytes: number, decimals = 2) {
  if (!+bytes) return '0 B'

  const k = 1024
  const dm = decimals < 0 ? 0 : decimals
  const sizes = ['B', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']

  const i = Math.floor(Math.log(bytes) / Math.log(k))

  return `${parseFloat((bytes / k ** i).toFixed(dm))} ${sizes[i]}`
}
